import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
    selector: 'file-audio-show-view',
    templateUrl: './file-audio-show-view.component.html',
    styleUrls: ['./file-audio-show-view.component.scss'],
})
export class FileAudioShowViewComponent implements AfterViewInit  {
    @Input() url: string = null;

    constructor(){}

    @ViewChild('componentContainer') containerRef!: ElementRef;

  currentWidth: number = 0;

  ngAfterViewInit(): void {
    // Es importante acceder al DOM dentro de ngAfterViewInit
    // El 'nativeElement' es el objeto DOM subyacente
    const element = this.containerRef.nativeElement as HTMLElement;
    
    // Usamos offsetWidth (el ancho del elemento incluyendo padding y borde)
    this.currentWidth = element.offsetWidth;

    element.style.width = '100%';
    
    console.log(`Ancho inicial del contenedor: ${this.currentWidth}px`);
  }

}